"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataExportJobRunClient = void 0;
const tslib_1 = require("tslib");
const authenticated_client_1 = require("../authenticated.client");
const data_export_utils_1 = require("./data-export-utils");
class DataExportJobRunClient extends authenticated_client_1.AuthenticatedClient {
    getExportJobRuns(request) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { accountId, projectId, jobId, state, order, page, limit } = request;
            const baseUrl = this.baseUrl(accountId);
            const queryParamsStr = makeQueryParams({ projectId, state, order, page, limit });
            const url = `${baseUrl}/${jobId}/runs?${queryParamsStr}`;
            const { success, payload, headers } = yield this.httpGet(url);
            if (!success) {
                return { values: [], links: {}, pageCount: 0 };
            }
            const links = (0, data_export_utils_1.readLinkHeader)(headers);
            return {
                values: payload,
                links,
                pageCount: (0, data_export_utils_1.getLastPageNumber)((_a = links.last) !== null && _a !== void 0 ? _a : links.first),
            };
        });
    }
    getSuccessfulJobRuns(request) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { accountId, projectId, format, scope, order, page, limit } = request;
            const baseUrl = this.baseUrl(accountId);
            const queryParamsStr = makeQueryParams({ projectId, format, scope, order, page, limit });
            const url = `${baseUrl}/successful-runs?${queryParamsStr}`;
            return this.internalGetSuccessfulJobRuns(url);
        });
    }
    getSuccessfulJobRunsWithUrl(fullUrl) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const urlObj = new URL(fullUrl);
            const url = `${urlObj.pathname}${urlObj.search}`;
            return this.internalGetSuccessfulJobRuns(url);
        });
    }
    internalGetSuccessfulJobRuns(url) {
        var _a;
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const { success, payload, headers } = yield this.httpGet(url);
            if (!success) {
                return { values: [], links: {}, pageCount: 0 };
            }
            const links = (0, data_export_utils_1.readLinkHeader)(headers);
            return {
                values: payload,
                links,
                pageCount: (0, data_export_utils_1.getLastPageNumber)((_a = links.last) !== null && _a !== void 0 ? _a : links.first),
            };
        });
    }
    getExportJobRun(accountId, projectId, jobId, jobRunId) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const baseUrl = this.baseUrl(accountId);
            const queryParamsStr = makeQueryParams({ projectId });
            const url = `${baseUrl}/${jobId}/runs/${jobRunId}?${queryParamsStr}`;
            const { payload } = yield this.httpGet(url);
            return payload;
        });
    }
    baseUrl(accountId) {
        return `/v1/accounts/${accountId}/exports`;
    }
}
exports.DataExportJobRunClient = DataExportJobRunClient;
function makeQueryParams(params) {
    return Object.entries(params)
        .filter(([_key, value]) => value !== undefined)
        .map(([key, value]) => `${key}=${value}`)
        .join('&');
}
//# sourceMappingURL=data-export-job-run.client.js.map